import { ProductCategory } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";

export async function getProductCategoryById(id: number | string): Promise<ProductCategory | void> {
  const localApi = await getLocalApi();

  return await localApi.fetchSingle(
    (apiConfig as any).reference_data_product_category_by_id.replace("{categoryId}", String(id)),
    mapProductCategory,
    "Failed to fetch Product Category by id"
  );
}

function mapProductCategory(dto: any): ProductCategory {
  return {
    id: dto?.id ?? dto?.categoryId ?? dto?.productCategoryId ?? 0,
    name: dto?.name ?? dto?.categoryName ?? "",
    createdBy: dto?.createdBy ?? "",
    lastModifiedBy: dto?.lastModifiedBy ?? "",
    active: typeof dto?.active === "boolean" ? dto.active : !!dto?.isActive,
    divisionId: dto?.divisionId ?? dto?.division?.id ?? 0,
  };
}